import { getAttributes } from '../utils';
import { Content, useContent } from '../../brite-viewer-v2/ContentProvider';
import { QRComponent } from './QRComponent';
import { Globe } from 'phosphor-react';
import { Box } from '../../../shared-components';

export const Website = ({ item, totalColumns }) => {
  const content = useContent();
  const mediaType = Content.getViewMode(content);
  const componentAttributes = getAttributes({
    column: item,
    length: totalColumns,
    type: 'component',
  });

  switch (mediaType) {
    case 'pdf': {
      return (
        <Box
          css={`
            width: 100%;
            padding: 8px;
          `}
        >
          <QRComponent Icon={Globe} title="Open Website" links={[{ url: componentAttributes?.src }]} />
        </Box>
      );
    }
    default: {
      return (
        <div {...componentAttributes}>
          <iframe {...componentAttributes}></iframe>
        </div>
      );
    }
  }
};
